import { Box, Typography, List, ListItem } from '@mui/material'

export default function ProgramRequirementsList({ requirements }) {
  return (
    <Box>
      {Object.entries(requirements).map(([type, data], idx) => (
        <Box key={idx} mb={2}>
          <Typography variant="h5">{type}</Typography>
          {data && data.requirements && data.requirements.length > 0 ? (
            <List>
              <Box
                p={3}
                border={1}
                borderColor="grey.300"
                borderRadius={2}
                mb={1}
              >
                {data.requirements.map((req, i) => (
                  <ListItem key={i}>
                    {req.name} - {req.description}
                  </ListItem>
                ))}
              </Box>
            </List>
          ) : (
            <Typography variant="body1">No requirements specified.</Typography>
          )}
        </Box>
      ))}
    </Box>
  )
}
